import { Regimen } from 'client/app/app-constant-types';
import { ProcessedRegimen, ProcessedRegimenProduct, RegimenViewState, DisplayStateOptions } from './regimen.types';
import { REGIMEN_VIEW_STATES } from './regimen.constants';

export function processRegimen(regimen: Regimen): ProcessedRegimen {
  if (!regimen?.objectId) return regimen as ProcessedRegimen;
  const processed: ProcessedRegimen = { ...regimen };
  processed.totalMRP = Math.round(processed.fixedPriceMRP ?? 0);
  processed.totalSP = processed.fixedPrice;
  processed.discount = processed.totalMRP
    ? Math.floor(((processed.totalMRP - (processed.totalSP ?? 0)) * 100) / processed.totalMRP)
    : 0;

  (['morning', 'night'] as const).forEach(slot => {
    (processed[slot] ?? []).forEach((item: ProcessedRegimenProduct) => {
      if (item.instruction && typeof item.instruction === 'string') {
        item.instruction = item.instruction.split('.').filter((ins: string) => ins.trim().length > 0);
      } else if (!item.instruction) {
        item.instruction = [item.product?.purposeDescription ?? '', 'Purchase regimen to see your instructions.'];
      }
    });
  });

  return processed;
}

export function isRegimenBeingPrepared(regimen: ProcessedRegimen): boolean {
  if (!regimen.objectId || !regimen.activeFrom || regimen.active || regimen.orderPlaced) return false;
  const toleranceSec = 5;
  const regimenShowTime = new Date(regimen.activeFrom.iso).getTime();
  return (regimenShowTime - Date.now()) / 1000 > toleranceSec;
}

export function getDisplayState(regimen: ProcessedRegimen | null, options?: DisplayStateOptions): RegimenViewState {
  if (!regimen?.objectId) {
    if (options?.consultationSession?.get('PrivateMainConcern')) return REGIMEN_VIEW_STATES.CHAT;
    return REGIMEN_VIEW_STATES.EMPTY;
  }
  if (isRegimenBeingPrepared(regimen)) return REGIMEN_VIEW_STATES.PREPARATION;
  const morning = regimen.morning ?? [];
  const night = regimen.night ?? [];
  const hasProducts = morning.length + night.length > 0;
  if (!hasProducts) return REGIMEN_VIEW_STATES.CONSULTATION;
  const hasInstructionSet = morning.every((p: ProcessedRegimenProduct) => p.instructionSet !== undefined)
    && night.every((p: ProcessedRegimenProduct) => p.instructionSet !== undefined);
  if (regimen.active && hasInstructionSet) return REGIMEN_VIEW_STATES.INSTRUCTION;
  return REGIMEN_VIEW_STATES.UNPAID;
}
